import { render, staticRenderFns } from "./AccountingReportHandover.vue?vue&type=template&id=b5ef3d30&scoped=true&"
import script from "./AccountingReportHandover.vue?vue&type=script&lang=js&"
export * from "./AccountingReportHandover.vue?vue&type=script&lang=js&"
import style0 from "./AccountingReportHandover.vue?vue&type=style&index=0&id=b5ef3d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ef3d30",
  null
  
)

export default component.exports